import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NgStyle } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'customer-g2m-intro',
  templateUrl: './g2m-intro.component.html',
  styleUrls: ['./g2m-intro.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, TranslatePipe]
})
export class G2mIntroComponent {
  readonly maxHeight = input<string>(undefined);
}
